// extracted by mini-css-extract-plugin
export default {"reasonsList":"Overview_reasonsList__tYCj+"};